import { Component } from '@angular/core'
import { MatRadioModule } from '@angular/material/radio'
import { ReactiveFormsModule } from '@angular/forms'
import { FieldType, FieldTypeConfig } from '@ngx-formly/core'
import { selectOption } from 'src/types/wizard'

@Component({
	selector: 'gwc-radio-button',
	templateUrl: './radio.button.component.html',
	styleUrls: ['./radio.button.component.scss'],
	imports: [
		MatRadioModule,
		ReactiveFormsModule
	]
})

export class RadioButtonComponent extends FieldType<FieldTypeConfig> {
	public radioOptions: selectOption[] = []

	ngOnInit(): void {
		console.log('radio button', {...this.props})
		this.radioOptions = this.props.options as Array<selectOption>
	}
}
